/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { setRhythmOptions } from '../store/options.actions'
import { VitalsService } from '../../vitals/services/vitals.service'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'

export function* getRhythmOptions() {
  const serviceId = yield select(getServiceIdSelector)
  const vitalsService = new VitalsService(serviceId)
  try {
    const rhythmOptions = yield call([vitalsService, vitalsService.getRhythmMethod])
    const { entity } = rhythmOptions
    yield put(setRhythmOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`getRhythmOptions() error: ${e}`))
  }
}

export function* getRhythmOptionsSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getRhythmOptions)
}
